<div class="main-container">
  <div>
    <div>
      Choose below to continue from an existing range
    </div>
    <button mat-icon-button (click)="expandAll= !expandAll" [matTooltip]="expandAll ? 'Collapse All' : 'Expand All'" style="margin-right:12px" class="expander-icon-color">
      <mat-icon>{{ expandAll ? 'expand_less' : 'expand_more'}}</mat-icon>
    </button>
  </div>
  <div style="height:100%; overflow:auto; padding:2px">
    <mat-accordion multi>
      <mat-expansion-panel *ngFor="let rangesByPrefix of batesRangeGroups | keyvalue" [expanded]="expandAll">
        <mat-expansion-panel-header>
          <mat-panel-title>{{rangesByPrefix.key}}</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-table [dataSource]="rangesByPrefix.value" class="mat-elevation-z0">
          <ng-container matColumnDef="produced">
            <mat-header-cell *matHeaderCellDef class="column-produced">Produced</mat-header-cell>
            <mat-cell *matCellDef="let element" class="column-produced">{{getBatesRange(element)}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="withheld">
            <mat-header-cell *matHeaderCellDef class="column-withheld">Withheld</mat-header-cell>
            <mat-cell *matCellDef="let element" class="column-withheld">{{element.batesRangeWithheld}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="dateTimeRun">
            <mat-header-cell *matHeaderCellDef class="column-total">Date Time Run</mat-header-cell>
            <mat-cell *matCellDef="let element" class="column-total">{{getDateTimeRunString(element)}}</mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
          <ng-container *ngIf="!isCreateMode">
            <mat-row *matRowDef="let row; columns: displayColumns;" (click)="selectProduction(row)" class="click-row"></mat-row>
          </ng-container>
          <ng-container *ngIf="isCreateMode">
            <mat-row *matRowDef="let row; columns: displayColumns;"></mat-row>
          </ng-container>
        </mat-table>
        <button mat-button *ngIf="isCreateMode" color="primary" (click)="continueWithExistingRange(rangesByPrefix.key)" style="margin:8px;">
          Create Production {{getNextBatesString(rangesByPrefix.key)}}
        </button>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
